import { render } from "./productsStock.vue?vue&type=template&id=356f05ae&scoped=true&ts=true"
import script from "./productsStock.vue?vue&type=script&lang=ts"
export * from "./productsStock.vue?vue&type=script&lang=ts"

import "./productsStock.vue?vue&type=style&index=0&id=356f05ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356f05ae"]])

export default __exports__